import { convertInputDuration } from "@smartsuite/fields-logic/lib/utils/duration";
import { $t } from "../../../utils/intl";
import type { FieldRegistryConfig } from "../../types";
import { fieldsText } from "../fields.text";
import { defaultToReviewString } from "../review/reviewString.helpers";
import { DurationFieldControl } from "./DurationFieldControl/DurationFieldControl";

export type DurationFieldValue = number;

export const durationFieldConfig: FieldRegistryConfig<DurationFieldValue> = {
  icon: "duration",
  control: (props) => (
    <DurationFieldControl {...props} placeholder={$t(fieldsText.durationPlaceholder)} />
  ),
  prefill: ({ value }) => {
    return convertInputDuration(value);
  },
  toReviewString: defaultToReviewString,
};
